import Swiper from "swiper";
import { FreeMode } from "swiper/modules";

export default class ResultsNav {
	constructor(nav) {
		this.nav = nav;
		this.swiperEl = nav.querySelector(".results-nav-swiper");
		if (!this.swiperEl) return;

		this.mq = window.matchMedia("(min-width: 992px)");
		this.swiper = null;

		this.mq.addEventListener("change", () => this.toggleSwiper());
		this.toggleSwiper();
	}

	toggleSwiper() {
		if (this.mq.matches) {
			this.destroySwiper();
		} else {
			this.initSwiper();
		}
	}

	initSwiper() {
		if (this.swiper) return;

		this.swiper = new Swiper(this.swiperEl, {
			modules: [FreeMode],
			slidesPerView: "auto",
			spaceBetween: 8,
			freeMode: {
				enabled: true,
			},
		});
	}

	destroySwiper() {
		if (!this.swiper) return;

		this.swiper.destroy(true, true);
		this.swiper = null;
	}
}
